module.exports = __webpack_public_path__ + "img/checkbox_not_active.a2e8ded5.svg";